import React, { useCallback, useState } from 'react';
import { useSend, useCall2 } from '@sc1/common/hooks';
import { Box, Row, Card, Heading, Input, Select } from '../core';
import { StatusButton } from '../StatusButton';
import type { CardProps } from 'theme-ui';
import { ScionTimelock } from '@sc1/common';

interface SetTimelockRoleProps extends CardProps {
  timelock: ScionTimelock | undefined;
  disabled: boolean;
}
export const SetTimelockRole = ({
  timelock,
  disabled,
  ...rest
}: SetTimelockRoleProps): JSX.Element => {
  const [address, setAddress] = useState<string>('');
  const [role, setRole] = useState<string>('');

  const { res: TIMELOCK_ADMIN_ROLE } = useCall2(timelock?.TIMELOCK_ADMIN_ROLE);
  const { res: PROPOSER_ROLE } = useCall2(timelock?.PROPOSER_ROLE);
  const { res: EXECUTOR_ROLE } = useCall2(timelock?.EXECUTOR_ROLE);

  const { sendTx, txStatus } = useSend();
  const { sendTx: sendTx1, txStatus: txStatus1 } = useSend();

  const grantRole = useCallback(
    () => timelock && sendTx(timelock, 'grantRole', [role, address]),
    [timelock, address, role, sendTx]
  );

  const revokeRole = useCallback(
    () => timelock && sendTx1(timelock, 'revokeRole', [role, address]),
    [timelock, address, role, sendTx1]
  );

  return (
    <Card {...rest}>
      <Heading as="h3" mb={2}>
        Set Timelock Roles
      </Heading>
      <Box>
        <Select
          my={2}
          onChange={(x) => setRole(x.target.value)}
          defaultValue="Select Role"
          disabled={disabled}
        >
          <option disabled>Select Role</option>
          <option value={TIMELOCK_ADMIN_ROLE}>Timelock Admin</option>
          <option value={PROPOSER_ROLE}>Timelock Proposer</option>
          <option value={EXECUTOR_ROLE}>Timelock Executor</option>
        </Select>
        <Input
          disabled={disabled}
          placeholder="0x..."
          value={address}
          onChange={(e) => setAddress(e.target.value)}
        />
        <Row variant="collapse" mt={2}>
          <StatusButton
            disabled={disabled}
            onClick={grantRole}
            status={txStatus}
          >
            Grant Role
          </StatusButton>
          <Box my={1} mx={1} />
          <StatusButton
            disabled={disabled}
            onClick={revokeRole}
            status={txStatus1}
          >
            Revoke Role
          </StatusButton>
        </Row>
      </Box>
    </Card>
  );
};
